import * as React from 'react';
import { Layout } from '../Layout';
import { VerticalSlider } from '../VerticalSlider';
import * as styles from './VideoSection.css';

interface IVideoSectionProps {
  title: React.ReactNode;
  videos: React.ReactNode;
  modal: React.ReactNode;
}

export function VideoSection({ title, videos, modal }: IVideoSectionProps) {
  return (
    <section id="video" className={styles['video']}>
      <Layout>
        <div className={styles['video__title']}>{title}</div>
        <VerticalSlider>{React.Children.map(videos, video => video)}</VerticalSlider>

        {modal}
      </Layout>
    </section>
  );
}
